/*
  Siamaya customizations.
  Carried over from the previous theme (Origin 13) in September 2026.
  Loaded with defer after global.js.
*/
(function () {
  // Header menus: close an open dropdown when the mouse moves away from it.
  document.querySelectorAll('[id^="Details-"] summary').forEach(function (summary) {
    var menuDetails = summary.closest('details');
    if (!menuDetails) return;
    var menuList = menuDetails.closest('ul');
    var bound = false;
    var close = function () {
      menuDetails.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    };
    summary.addEventListener('mouseover', function () {
      if (bound) return;
      bound = true;
      if (menuList) menuList.addEventListener('mouseleave', close);
      menuDetails.addEventListener('mouseleave', close);
    });
  });

  // Social links open in a new tab.
  document.querySelectorAll('a.list-social__link').forEach(function (link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
  });
})();
